import { switchMap } from 'rxjs';
import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { AppDisconnectedEvent } from '@platform/event-bus/domain/events/app-disconnected.event';
import { SERVICE_STATE_SERVICE } from '@features/service/domain/tokens/service-state.token';


@Injectable({ providedIn: 'root' })
export class ServiceCleanDataSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(SERVICE_STATE_SERVICE);

  constructor() {
    this.eventBus.ofType(AppDisconnectedEvent).pipe(
      switchMap(() => this.serviceStateService.clear()),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}